/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { isMobile } from 'react-device-detect'

import { message } from 'antd'
// icon
import { ChangeBtnIco } from '@shared/Icon/EtcIcon'
import { Button, ButtonWrap, ModalFooterWrap, PopupBtnStyle } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import MyItem from '@views/MyItem'
import { VIEW_TYPE } from '@constants/index'
import { UserItem } from '@store/userStore'
import PopupUtils from '@utils/popup-utils'

const SkinDrawer: React.FC = () => {
  const { userStore, routerStore, globalStore, authStore } = useRootStore()
  const [selectedUserItem, setSelectedUserItem] = useState<UserItem>(null)
  const [disableUseItem, setDisableUseItem] = useState(false)
  const { history } = routerStore

  const skinPropertyIds = [PROPERTY_ID.AVATAR]

  const useItem = async () => {
    if (!selectedUserItem) {
      message.error('변경할 스킨을 선택해주세요')
      return
    }

    if (selectedUserItem && userStore.userCharacter === selectedUserItem.link_index) {
      message.error('기존과 동일한 스킨입니다.')
      return
    }

    setDisableUseItem(true)
    await userStore.userUseItem({ itemId: selectedUserItem.id })
    message.info('스킨이 변경 되었습니다')
    authStore.changeUserAvatar(selectedUserItem.icon_m)
    setDisableUseItem(false)
    globalStore.closeGeneralPopup()
    globalStore.setVisibleChangeProfile(false)
  }

  const onClickJumpSkinShopButton = () => {
    if (isMobile) {
      globalStore.closeGeneralPopup()
      globalStore.setVisibleChangeProfile(false)
      history.push('/itemshop')
    } else {
      PopupUtils.showItemShopPopup()
    }
  }

  const setSelectedUserItemToParent = (selectItem: UserItem, selectItemCount: number): void => {
    setSelectedUserItem(selectItem)
  }

  return (
    <Fragment>
      <MyItem
        propertyIds={skinPropertyIds}
        viewType={VIEW_TYPE.SKIN_SELECTOR}
        setSelectedUserItemToParent={setSelectedUserItemToParent} />
      <ModalFooterWrap css={{ position: 'absolute' }}>
        <ButtonWrap>
          <Button
            css={PopupBtnStyle}
            onClick={onClickJumpSkinShopButton}
            className="two-button cancel bottom-btn modal">
            스킨 구매하기
          </Button>
          <Button
            primary
            disabled={disableUseItem}
            onClick={useItem}
            css={PopupBtnStyle}
            className="two-button bottom-btn modal">
            <ChangeBtnIco />변경하기
          </Button>
        </ButtonWrap>
      </ModalFooterWrap>
    </Fragment>
  )
}

export default observer(SkinDrawer)
